import React, { PureComponent } from 'react';
import { Form, Radio } from 'antd';
import { language } from '../../../language';
import { services } from '@comall-backend-builder/core';
import { ColorPicker, EntryList, FormItemLayout, ConfigFormDecorator } from '../../tools';
import { SearchBarTips } from './search-bar-tips';
import { SearchBarItem } from './search-bar-item';
import './index.less';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const MAX_ENTRY_COUNT = 10;

const interpolate = services.interpolate;

export class searchBar extends PureComponent<any> {
    WrapSearchItem = (props) => {
        const { selector } = this.props;
        return <SearchBarItem key={props.index} {...props} selector={selector} />;
    };
    render() {
        const {
            form: { getFieldDecorator },
            linkTypes,
            linkTypeMode,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="editor-search-bar">
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.SearchBar.shape')}
                >
                    {getFieldDecorator('shape')(
                        <RadioGroup className="show-style">
                            <Radio value={'square'}>
                                {language.getText('components.SearchBar.square')}
                            </Radio>
                            <Radio value={'round'}>
                                {language.getText('components.SearchBar.round')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.SearchBar.backgroundColor')}
                >
                    {getFieldDecorator('backgroundColor')(<ColorPicker />)}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.SearchBar.shapeColor')}
                >
                    {getFieldDecorator('boxBackgroundColor')(<ColorPicker />)}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.SearchBar.textAlign')}
                >
                    {getFieldDecorator('textAlign')(
                        <RadioGroup className="show-style">
                            <Radio value={'left'}>
                                {language.getText('components.SearchBar.left')}
                            </Radio>
                            <Radio value={'center'}>
                                {language.getText('components.SearchBar.center')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.SearchBar.textColor')}
                >
                    {getFieldDecorator('fontColor')(<ColorPicker />)}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapSearchItem}
                            renderTips={SearchBarTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.SearchBar.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Form>
        );
    }
}
export const SearchBar = ConfigFormDecorator(searchBar);
